import mapboxgl from 'mapbox-gl';

const {
    accessToken = null,
    mapboxStyleUsername = null,
    mapboxStyleId = null,
} = window.MapboxConfig;

mapboxgl.accessToken = accessToken;

const initializeMap = mapContainer => {
    const branches = JSON.parse(window[`map_block_${mapContainer.dataset.mapBlock}`]);
    const bounds = branches.reduce(
        (boundsObject, branch) => boundsObject.extend([branch.longitude, branch.latitude]),
        new mapboxgl.LngLatBounds(),
    );

    const map = new mapboxgl.Map({
        container: mapContainer,
        center: [
            branches[0].longitude,
            branches.length > 1 ? branches[0].latitude : branches[0].latitude + 0.012,
        ],
        zoom: 12.5,
        bounds: branches.length > 1 ? bounds : false,
        fitBoundsOptions: branches.length > 1 ? { padding: 100 } : false,
        style: `mapbox://styles/${mapboxStyleUsername}/${mapboxStyleId}`,
        cooperativeGestures: true,
    });

    map.on('load', async () => {
        const geojson = {
            type: 'FeatureCollection',
            features: branches.map(branch => ({
                type: 'Feature',
                properties: {
                    headline: branch.headline,
                    address: branch.address,
                    email: branch.email,
                    phone_readable: branch.phone_readable,
                    phone_machine: branch.phone_machine,
                    link: branch.link,
                    self_relation: branch.self_relation,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [branch.longitude, branch.latitude],
                },
            })),
        };

        map.addControl(new mapboxgl.NavigationControl());

        map.addSource('branches', {
            type: 'geojson',
            data: geojson,
        });

        map.loadImage('/dist/images/marker.png', function (error, image) {
            if (error) {
                map.addLayer({
                    id: 'marker',
                    type: 'circle',
                    source: 'branches',
                    filter: ['!', ['has', 'point_count']],
                    paint: {
                        'circle-color': '#1558A0',
                        'circle-radius': 20,
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#fff',
                    },
                });
                throw error;
            }

            map.addImage('custom-marker', image);
            map.addLayer({
                id: 'marker',
                type: 'symbol',
                source: 'branches',
                layout: {
                    'icon-image': 'custom-marker',
                    'icon-size': 0.5,
                    'icon-allow-overlap': true,
                },
            });
        });

        const showPopupForMarker = marker => {
            const coordinates = marker.geometry.coordinates.slice();
            const { headline, address, email, phone_machine, phone_readable, link, self_relation } =
                marker.properties;
            const directionsLinkLabel = mapContainer.dataset.directionsLinkLabel;
            const branchButtonLabel = mapContainer.dataset.branchButtonLabel;
            const googleMapsDestination = encodeURIComponent(
                headline + ' ' + address.replace(/(<([^>]+)>)/gi, ' '),
            );
            const googleMapsDirectionsLink =
                'https://www.google.com/maps/dir/?api=1&travelmode=bicycling&destination=' +
                googleMapsDestination;

            new mapboxgl.Popup({ focusAfterOpen: false })
                .setLngLat(coordinates)
                .setMaxWidth('none')
                .setOffset([0, -28])
                .setHTML(
                    `<div class="map__popup map-popup">
                        <div class="map-popup__content">
                            <h3 class="map-popup__headline">${headline}</h3>
                            <p class="mb-2">${address}</p>
                            <p class="mb-0">
                                <a class="map-popup__link" href="mailto:${email}">
                                    <svg class="map-popup__link-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V128zM32 128V167.9L227.6 311.3C244.5 323.7 267.5 323.7 284.4 311.3L480 167.9V128C480 110.3 465.7 96 448 96H63.1C46.33 96 31.1 110.3 31.1 128H32zM32 207.6V384C32 401.7 46.33 416 64 416H448C465.7 416 480 401.7 480 384V207.6L303.3 337.1C275.1 357.8 236.9 357.8 208.7 337.1L32 207.6z"></path></svg>
                                    <span>${email}</span>
                                </a><br>
                                <a class="map-popup__link" href="${phone_machine}">
                                    <svg class="map-popup__link-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M484.6 330.6C484.6 330.6 484.6 330.6 484.6 330.6l-101.8-43.66c-18.5-7.688-40.2-2.375-52.75 13.08l-33.14 40.47C244.2 311.8 200.3 267.9 171.6 215.2l40.52-33.19c15.67-12.92 20.83-34.16 12.84-52.84L181.4 27.37C172.7 7.279 150.8-3.737 129.6 1.154L35.17 23.06C14.47 27.78 0 45.9 0 67.12C0 312.4 199.6 512 444.9 512c21.23 0 39.41-14.44 44.17-35.13l21.8-94.47C515.7 361.1 504.7 339.3 484.6 330.6zM457.9 469.7c-1.375 5.969-6.844 10.31-12.98 10.31c-227.7 0-412.9-185.2-412.9-412.9c0-6.188 4.234-11.48 10.34-12.88l94.41-21.91c1-.2344 2-.3438 2.984-.3438c5.234 0 10.11 3.094 12.25 8.031l43.58 101.7C197.9 147.2 196.4 153.5 191.8 157.3L141.3 198.7C135.6 203.4 133.8 211.4 137.1 218.1c33.38 67.81 89.11 123.5 156.9 156.9c6.641 3.313 14.73 1.531 19.44-4.219l41.39-50.5c3.703-4.563 10.16-6.063 15.5-3.844l101.6 43.56c5.906 2.563 9.156 8.969 7.719 15.22L457.9 469.7z"></path></svg>
                                    <span>${phone_readable}</span>
                                </a><br>
                                <a class="map-popup__link" href="${googleMapsDirectionsLink}" rel="noopener" target="_blank">
                                    <svg class="map-popup__link-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M497.1 222.1l-208.1-208.1c-9.354-9.355-21.63-14.03-33.89-14.03S231.5 4.674 222.1 14.03L14.03 222.1C4.677 231.5 .0006 243.7 .0004 255.1C.0001 268.3 4.676 280.5 14.03 289.9l208.1 208.1C231.5 507.3 243.7 511.1 256 511.1s24.52-4.679 33.87-14.03l208.1-208.1c9.353-9.356 14.03-21.61 14.03-33.87C511.1 243.7 507.3 231.5 497.1 222.1zM475.3 267.2l-208.1 208.1C263.2 479.4 258.5 480 256 480s-7.191-.6055-11.24-4.66L36.66 267.3c-6.201-6.203-6.201-16.29-.002-22.49l208.1-208.1C248.8 32.61 253.5 32 256 32s7.191 .6055 11.24 4.66l208.1 208.1C481.5 250.1 481.5 261 475.3 267.2zM315.3 148.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L345.4 224H240C213.5 224 192 245.5 192 272v64C192 344.8 199.2 352 208 352S224 344.8 224 336l-.0002-64C223.1 263.2 231.2 256 240 256h105.4l-52.69 52.69c-6.25 6.25-6.25 16.38 0 22.62C295.8 334.4 299.9 336 304 336s8.188-1.562 11.31-4.688l80-80c6.25-6.25 6.25-16.38 0-22.62L315.3 148.7z"></path></svg>
                                    <span>${directionsLinkLabel}</span>
                                </a>
                            </p>
                            ${
                                !self_relation
                                    ? `<a class="map-popup__button btn btn-primary mt-3" href="${link}">${branchButtonLabel}</a>`
                                    : ''
                            }
                        </div>
                    </div>`,
                )
                .addTo(map);
        };

        map.on('click', 'marker', e => showPopupForMarker(e.features[0]));

        if (branches.length == 1) {
            showPopupForMarker(geojson.features[0]);
        }

        map.on('mouseenter', 'marker', () => {
            map.getCanvas().style.cursor = 'pointer';
        });

        map.on('mouseleave', 'marker', () => {
            map.getCanvas().style.cursor = '';
        });
    });
};

const mapBlocks = Array.from(document.querySelectorAll('[data-map-block]'));

mapBlocks.forEach(mapContainer => {
    const consentManager = window.klaro.getManager();

    if (consentManager.getConsent('mapbox')) {
        return initializeMap(mapContainer);
    }

    consentManager.watch({
        update(obj, name, data) {
            if (name !== 'applyConsents') return;
            if (!obj.states.mapbox) return;
            initializeMap(mapContainer);
        },
    });
});
